import Bugsnag from "@bugsnag/js";
import { FunctionComponent, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Contact from "@Components/organisms/Contact";
import Footer from "@Components/organisms/Footer";
import Header from "@Components/organisms/Header";
import WithGlobalLoader, { useGlobalLoader } from "@Components/WithGlobalLoader";
import CheerzApiProvider from "@Providers/CheerzApiProvider";
import UserContent from "@Types/user";
import { getCsrfToken, getMetaContent } from "@Utils/meta";
import { convertToIdentifyProperties, setDataLayerTrack } from "@Utils/track";
import { convertUserFromApiToContent } from "@Utils/user";

interface Props {
  localizationSlug: string;
}

const ContactPage: FunctionComponent<Props> = ({ localizationSlug }) => {
  const [user, setUser] = useState<UserContent>();
  const { setLoading } = useGlobalLoader();
  const intl = useIntl();

  useEffect(() => {
    setLoading(true);
    const cheerzApiProvider = new CheerzApiProvider(localizationSlug, getCsrfToken(), true);

    cheerzApiProvider
      .getUser()
      .then((userData) => {
        setUser(convertUserFromApiToContent(userData));
        setDataLayerTrack("Global", {
          currency: userData.currency,
          environment: getMetaContent("cheerz-env") === "production" ? "production" : "test",
          locale: intl.locale,
        });
        setDataLayerTrack(
          "Identify",
          convertToIdentifyProperties(convertUserFromApiToContent(userData))
        );
        setDataLayerTrack("Page", {
          category: "Other",
          name: "Contact",
          path: `/${intl.locale}/contact-us`,
          version: "A",
        });
        setLoading(false);
      })
      .catch((error: Error) => {
        Bugsnag.notify(error);
      });
  }, []);

  if (user) {
    return (
      <>
        <Header userData={user} />
        <Contact />
        <Footer userData={user} />
      </>
    );
  } else return null;
};

const ContactPageContainer: FunctionComponent<Props> = ({ localizationSlug }) => {
  return (
    <WithGlobalLoader initialLoading={true}>
      <ContactPage localizationSlug={localizationSlug} />
    </WithGlobalLoader>
  );
};

export default ContactPageContainer;
